
sessionStorage.removeItem(document.location.hostname + '-storredNewsData');
var storredNews = sessionStorage.getItem(document.location.hostname + '-storredNewsData');
if (storredNews) {
    var storredNews = JSON.parse(storredNews);
    $('#footer .custom-footer').before(storredNews);
} else {
    $.ajax({
        url: '/magazin/',
        type: 'GET',
        success: function (response) {
            var content = $(response);
            var newsItems = content.find('.news-item').slice(0, 3);
            var combinedHtml = '';
            newsItems.each(function (index, element) {
                var $element = $(element);
                var $elementImage = $element.find('.image img').attr('data-src') || $element.find('.image img').attr('src');
                var $elementTitle = $element.find('.title').text().trim();
                var $elementCreated = $element.find('time').text().trim();
                var $elementLink = $element.find('.title').attr('href');
                var $elementDescription = $element.find('.description').html();
                combinedHtml += `
                    <div class="newsItem">
                        <div class="image">
                            <a href="${$elementLink}" class="title">
                                <img src="${$elementImage}">
                            <span>${$elementCreated}</span>
                            </a>
                        </div>
                        <a href="${$elementLink}" class="text">
                            <div class="h4">${$elementTitle}</div>
                            <span class="description">${$elementDescription}</span>
                        </a>
                    </div>
                `;
            });
            var wrappedHtml = '<div class="container blogWrapper">' + combinedHtml + '</div>';
            $('#footer .custom-footer').before(wrappedHtml)
            sessionStorage.setItem(document.location.hostname + '-storredNewsData', JSON.stringify(wrappedHtml));
        },
        error: function (xhr, status, error) {
            console.error("Error fetching rating data:", status, error);
        }
    }).done(function () {
    });
}


